import { useContext, useEffect } from 'react'
import { GlobalContext } from '../Global'
import { getQueryParams } from '../../helpers'
import * as S from './styles'
import { Loader } from '../../components'

const Layout = ({ children }) => {
  const {
    state: { forgotDetails },
    dispatch,
  } = useContext(GlobalContext)

  useEffect(() => {
    const params = getQueryParams()
    if (params.maggiortutela) {
      dispatch({ type: 'changeIsAlternativeActive', payload: true })
      const favicon = document.getElementById('favicon')
      favicon.href = '../../assets/images/favicon_alt.ico'
    }
  }, [dispatch])

  let isByePage = window.location.href.indexOf('failed-login') > -1

  return (
    <S.LayoutWrapper>
      <Loader fullPage id="loader-scripts" />
      <S.LayoutTitlesContainer showAlways={forgotDetails}>
        <S.LayoutTitle forgotDetails={forgotDetails}>Accedi</S.LayoutTitle>
        {!isByePage && (
          <S.LayoutSubtitle>
            {forgotDetails
              ? 'Password o nome utente dimenticati'
              : 'Entra nella tua Area Clienti'}
          </S.LayoutSubtitle>
        )}
      </S.LayoutTitlesContainer>
      <S.LayoutContentWrapper>{children}</S.LayoutContentWrapper>
    </S.LayoutWrapper>
  )
}

export default Layout
